const getters = {
	appid(state) {
		return state.appid;
	},

	redirectURL(state) {
		return state.redirectURL;
	}
};

export default getters